/**
 * Sleeve Stars — Homepage DOM patches.
 *  1) Quiz: position the quiz mount after the blog/journal section
 *     and hide "Move pain-free" tagline.
 *  2) Ambassadors: move above Benefits.
 *  3) Hide empty banner sections.
 *  4) Collapse everything between newsletter and footer.
 */
(function () {
  function findSectionByText(matcher, skipFn) {
    const sections = document.querySelectorAll('.shopify-section');
    for (const s of sections) {
      if (skipFn && skipFn(s)) continue;
      const text = (s.textContent || '').toLowerCase();
      if (matcher(text)) return s;
    }
    return null;
  }

  function findBlogSection() {
    const blog = document.querySelector('.shopify-section .blog');
    return blog ? blog.closest('.shopify-section') : null;
  }

  function findNewsletterSection() {
    const nl = document.querySelector('.shopify-section .newsletter');
    return nl ? nl.closest('.shopify-section') : null;
  }

  function findFooterSection() {
    return (
      document.querySelector('.shopify-section-footer-group') ||
      document.querySelector('.shopify-section-footer-template') ||
      document.querySelector('[id*="footer-group"]') ||
      document.querySelector('[id*="footer-template"]') ||
      document.querySelector('footer') ||
      null
    );
  }

  function hideEmptyBanners() {
    document.querySelectorAll('.shopify-section .banner').forEach(banner => {
      const section = banner.closest('.shopify-section');
      if (!section || section.dataset.ssEmptyChecked) return;
      section.dataset.ssEmptyChecked = '1';
      if (banner.classList.contains('banner--ss-video')) return;
      if (section.querySelector('.ss-quiz')) return;
      const heading = banner.querySelector('.banner__heading');
      const text = banner.querySelector('.banner__text');
      const placeholder = banner.querySelector('.placeholder-svg, .placeholder');
      const headingText = (heading && heading.textContent || '').trim();
      const bodyText = (text && text.textContent || '').trim();
      const looksEmpty =
        (!headingText && !bodyText) ||
        (placeholder && !headingText && !bodyText);
      if (looksEmpty) {
        section.style.display = 'none';
        section.setAttribute('data-ss-empty', '1');
      }
    });
  }

  function collapseBetweenNewsletterAndFooter() {
    const nl = findNewsletterSection();
    const footer = findFooterSection();
    if (!nl || !footer) return;
    let cursor = nl.nextElementSibling;
    while (cursor && cursor !== footer && !footer.contains(cursor) && !cursor.contains(footer)) {
      const next = cursor.nextElementSibling;
      cursor.style.display = 'none';
      cursor.setAttribute('data-ss-orphan', '1');
      cursor = next;
    }
  }

  function injectQuiz() {
    const mount = document.getElementById('ss-quiz-mount');
    if (!mount) return;
    if (mount.dataset.ssDone === '1') return;

    const externalQuiz = document.querySelector('.ss-quiz');
    if (externalQuiz && !mount.contains(externalQuiz)) {
      mount.parentNode && mount.parentNode.removeChild(mount);
      return;
    }

    const tagline = findSectionByText(
      t => t.indexOf('move pain-free') !== -1 ||
           t.indexOf("that's the whole brief") !== -1 ||
           t.indexOf('the whole brief') !== -1,
      s => s === mount || s.contains(mount) || (s.querySelector && s.querySelector('.ss-quiz'))
    );
    if (tagline) {
      tagline.style.display = 'none';
      tagline.setAttribute('data-ss-hidden', '1');
    }

    const blogSection = findBlogSection();
    if (blogSection && blogSection.parentNode) {
      if (blogSection.nextElementSibling !== mount) {
        blogSection.parentNode.insertBefore(mount, blogSection.nextElementSibling);
      }
    }

    mount.style.display = '';
    mount.dataset.ssDone = '1';
  }

  function moveAmbassadors() {
    const ambSection =
      (document.querySelector('.ss-amb') && document.querySelector('.ss-amb').closest('.shopify-section')) ||
      findSectionByText(
        t => t.indexOf('meet the ambassadors') !== -1 ||
             t.indexOf('faces of sleeve stars') !== -1 ||
             t.indexOf('real days. real relief') !== -1
      );
    if (!ambSection || ambSection.dataset.ssAmbMoved === '1') return;

    const benefits = findSectionByText(
      t => t.indexOf('benefits of compression') !== -1 ||
           t.indexOf('four jobs. one sleeve') !== -1,
      s => s === ambSection
    );
    if (!benefits) return;

    if (benefits.previousElementSibling !== ambSection) {
      benefits.parentNode.insertBefore(ambSection, benefits);
    }
    ambSection.dataset.ssAmbMoved = '1';
  }

  function run() {
    hideEmptyBanners();
    moveAmbassadors();
    injectQuiz();
    collapseBetweenNewsletterAndFooter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-ss-empty-checked]').forEach(el => { el.dataset.ssEmptyChecked = ''; });
    document.querySelectorAll('[data-ss-amb-moved]').forEach(el => { el.dataset.ssAmbMoved = ''; });
    document.querySelectorAll('[data-ss-orphan]').forEach(el => { el.removeAttribute('data-ss-orphan'); el.style.display = ''; });
    const mount = document.getElementById('ss-quiz-mount');
    if (mount) mount.dataset.ssDone = '';
    run();
  });
})();
